import { render, staticRenderFns } from "./Facilitations.vue?vue&type=template&id=2c97a148&scoped=true"
import script from "./Facilitations.vue?vue&type=script&lang=js"
export * from "./Facilitations.vue?vue&type=script&lang=js"
import style0 from "./Facilitations.vue?vue&type=style&index=0&id=2c97a148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97a148",
  null
  
)

export default component.exports